import * as TweenJS from "slotworks/utils/tween";
import Contract from "slotworks/utils/contract";
import { FadeIn, ZoomIn, ZoomOut, FadeOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { PIXIElement, CenterPivot } from "slotworks/graphics/pixi/group";
import { sequence, parallel } from "slotworks/utils/race-utils";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Timer from "slotworks/utils/timer";
import { GlowTransitionCommand } from "commands/glow-transition-command";
import deviceInfo from "slotworks/utils/device-info";


export default class PromtsGlowTransition extends AbstractSceneTransition {

    private container: PIXI.Container;
    private background: PIXI.Sprite;

    public in(): Contract<void> {
        const backgound = Layers.CelebrationBackground.getSprite("fullscreen");
        FadeIn(backgound, 200).execute();
        this.background = Layers.Prompts.container.children[0] as PIXI.Sprite;
        this.container = CenterPivot([...(Layers.Prompts.container.children as PIXIElement[])], "prompt_tmp");
        return sequence([
            () => this.zoomIn(this.container, 400),
            () => Contract.wrap(() => {
                if(!deviceInfo.isDesktop) {
                    deviceInfo.onLayoutChange.add(this.onLayoutChange);
                }
            })
        ]);
    }

    public out(): Contract<void> {
        const backgound = Layers.CelebrationBackground.getSprite("fullscreen");
        Timer.setTimeout(() => GlowTransitionCommand().execute(), 150);
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.remove(this.onLayoutChange);
        }
        return parallel([
            () => this.zoomOut(this.container, 400),
            () => FadeOut(backgound, 400)
        ]);
    }

    private onLayoutChange = () => {
        setTimeout(() => {
            const position = Layers.Prompts.getPosition("prompt");
            this.container.position.set(position.x + position.width/2, position.y + position.height/2);
            const difference = position.width / this.background.width;
            this.container.scale.set(difference, difference);
        }, 1);
    }

    private zoomIn(container: PIXI.Container, time: number):Contract<void> {
        return new Contract(resolve => {
            this.container.scale.set(0, 0);
            new TweenJS.Tween(container.scale)
            .to({x: 1, y: 1}, time)
            .easing(TweenJS.Easing.Back.Out)
            .onComplete(resolve)
            .start();
        });
    }

    private zoomOut(container: PIXI.Container, time: number):Contract<void> {
        return new Contract(resolve => {
            new TweenJS.Tween(container.scale)
            .to({x: 0, y: 0}, time)
            .easing(TweenJS.Easing.Back.In)
            .onComplete(resolve)
            .start();
        });
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/prompts-glow-transition.ts